export const IntegerAxis = {
  format: (e) => Math.floor(e) === e ? e : "",
};

export const SkipTicksAxis = (hardcodedLabelLength, width, dataToMatch) => {
  return {
    format: (val) => {
      if (!dataToMatch) return "";
      const ftIdx = dataToMatch.findIndex((vts) => vts.x === val);
      const tickWidth = width / dataToMatch.length;
      let numTicksPerLabel = Math.floor(hardcodedLabelLength / tickWidth);
      numTicksPerLabel = Math.max(numTicksPerLabel, 1);
      if (ftIdx % numTicksPerLabel === 0) return val;
      return "";
    },
  };
};
